import { ReactType, ComponentType } from 'react';

export default function getDisplayName(WrappedComponent: ReactType): string {
  if (typeof WrappedComponent === 'symbol') {
    return 'Component';
  }

  return (WrappedComponent as ComponentType).displayName || (WrappedComponent as ComponentType).name || 'Component';
}
